import { createTheme } from '@mui/material/styles'
import { esES } from '@mui/material/locale';
import chroma from 'chroma-js'

function getPallete(color) {
  const primary = chroma(color).set('hsl.l', '*0.5').set('hsl.s', '*1.2').hex()
  const complementary = chroma(color).set('hsl.h', '+180').set('hsl.l', '*0.5').set('hsl.s', '*1.2').hex()
  const analogous = chroma(color).set('hsl.h', '+30').set('hsl.l', '*0.5').set('hsl.s', '*1.2').hex()
  const triadic = chroma(color).set('hsl.h', '+120').set('hsl.l', '*0.5').set('hsl.s', '*1.2').hex()
  const error = chroma(color).set('hsl.h', 0).hex()
  const contrast = chroma.contrast(color, 'white') > 4.5 ? '#CACACA' : '#FEFEFE'

  return { primary, complementary, analogous, triadic, error, contrast }
}


const getTheme = (color) => {

  const { primary, complementary, analogous, triadic, error, contrast } = getPallete(color)

  const source = {
    palette: {
      primary: {
        main: primary,
      },
      secondary: {
        main: complementary,
      },
      info: {
        main: analogous,
      },
      success:{
        main: triadic,
      },
      error: {
        main: error,
      },
      contrast: {
        main: contrast,
      },
    },
  }

  return createTheme(source, esES)
}

export default getTheme